import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Newsletter functionality would be implemented here
    setEmail('');
  };

  return (
    <footer className="bg-gray-900 border-t-2 border-brand">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 lg:py-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Column 1 - Brand */}
          <div className="col-span-2 lg:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/13edce89-4f16-4e98-b06b-55fd33dbf2eb.png" 
              alt="All Phases Builders LLC" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm mb-4">
              Building Excellence Since 2010
            </p>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Delivering quality construction and remodeling services with integrity, professionalism, and exceptional craftsmanship.
            </p>
            <div className="flex space-x-3">
              <div className="bg-gray-800 px-3 py-1 rounded text-xs text-gray-300">
                <i className="ri-shield-check-line mr-1"></i>
                Licensed
              </div>
              <div className="bg-gray-800 px-3 py-1 rounded text-xs text-gray-300">
                <i className="ri-shield-check-line mr-1"></i>
                Insured
              </div>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-white text-xs font-semibold uppercase tracking-wider mb-6">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Our Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Contact
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Request Quote
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h3 className="text-white text-xs font-semibold uppercase tracking-wider mb-6">
              Our Services
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Framing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Siding
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Roofing
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Decking
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  Windows & Doors
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-brand transition-colors text-sm"
                >
                  General Construction
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div className="col-span-2 lg:col-span-1">
            <h3 className="text-white text-xs font-semibold uppercase tracking-wider mb-6">
              Stay Updated
            </h3>
            <p className="text-gray-400 text-sm mb-4">
              Get construction tips and project updates
            </p>
            <form onSubmit={handleNewsletterSubmit} className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                required
                className="w-full bg-gray-800 border border-white/20 text-white placeholder-gray-500 py-3 px-4 pr-12 rounded-lg focus:outline-none focus:border-brand transition-colors text-sm"
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-brand text-white w-8 h-8 rounded flex items-center justify-center hover:bg-brand-dark transition-colors"
                aria-label="Subscribe"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
            <p className="text-gray-500 text-xs mt-3">
              We respect your privacy
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0 text-center sm:text-left">
            <p className="text-gray-400 text-sm">
              © 2025 All Phases Builders LLC. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-brand transition-colors text-sm">
                Privacy Policy
              </a>
              <span className="text-gray-600">|</span>
              <a href="#" className="text-gray-400 hover:text-brand transition-colors text-sm">
                Terms of Service
              </a>
              <span className="text-gray-600">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand transition-colors text-sm">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
